@if (config) {
<div class="dt-card">

  <!-- Brillo decorativo: termina en el color de fondo, nunca en negro -->
  <div class="dt-card__glow" [style.background]="
    'radial-gradient(circle, ' + accent + '28 0%, var(--cc-card-bg) 72%)'">
  </div>

  <!-- Header -->
  <div class="dt-card__header">
    <span class="dt-card__dot" [style.background]="accent"
          [style.box-shadow]="'0 0 8px ' + accent + '99'"></span>
    <span class="dt-card__title">{{ config.title }}</span>
  </div>

  <!-- Cuerpo: valor + delta -->
  <div class="dt-card__body">

    <div class="dt-card__metric">
      <span class="dt-card__value">{{ formattedValue }}</span>
      @if (config.valueLabel) {
        <span class="dt-card__value-label">{{ config.valueLabel }}</span>
      }
    </div>

    @if (config.delta !== undefined) {
      <div class="dt-card__delta" [class.dt-card__delta--up]="deltaPositive"
                                  [class.dt-card__delta--down]="!deltaPositive">
        <span class="dt-card__delta-arrow">{{ deltaPositive ? '↑' : '↓' }}</span>
        <span class="dt-card__delta-val">{{ deltaAbs | number:'1.0-0' }}</span>
        @if (config.deltaLabel) {
          <span class="dt-card__delta-label">{{ config.deltaLabel }}</span>
        }
      </div>
    }

  </div>

  <!-- Sparkline SVG -->
  @if (sparkPath) {
  <div class="dt-card__chart">
    <svg [attr.viewBox]="'0 0 ' + W + ' ' + H" preserveAspectRatio="none"
         xmlns="http://www.w3.org/2000/svg" style="display:block;overflow:visible">
      <defs>
        <linearGradient [id]="gradId" x1="0" y1="0" x2="0" y2="1">
          <!-- stop-opacity en lugar de transparent → evita el fade a negro -->
          <stop offset="0%"   [style.stopColor]="accent" [style.stopOpacity]="0.3" />
          <stop offset="100%" [style.stopColor]="accent" [style.stopOpacity]="0.02" />
        </linearGradient>
      </defs>

      <!-- Área rellena -->
      <path [attr.d]="areaPath" [attr.fill]="'url(#' + gradId + ')'" />

      <!-- Línea suavizada -->
      <path [attr.d]="sparkPath"
            [attr.stroke]="accent"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round" />

      <!-- Punto final destacado -->
      @if (sparkPoints.length) {
        <circle
          [attr.cx]="sparkPoints[sparkPoints.length - 1].x"
          [attr.cy]="sparkPoints[sparkPoints.length - 1].y"
          r="3"
          [attr.fill]="accent"
          [attr.stroke]="accent + '44'"
          stroke-width="5" />
      }
    </svg>
  </div>
  }

</div>
}
